var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('prd-navigation-bar',[_c('top-bar-breadcrumb',{attrs:{"is-me":true,"section":'directory'}}),_c('profile',{attrs:{"slot":"right"},slot:"right"}),(!_vm.isInvoicesSection)?_c('consumer-selector',{attrs:{"slot":"right"},slot:"right"}):_c('legal-entity-selector',{attrs:{"slot":"right"},slot:"right"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }